// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/gridConnector.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-FeatureSection-module__featureSectionContainer-Zn9fx {
  width: 100%;
  background-color: var(--background-secondary);
}

.nightbot-FeatureSection-module__featurePanels-sP3KG {
  gap: 32px;
}

.nightbot-FeatureSection-module__featurePanel-nbYWi {
  overflow: hidden;
  gap: 8px;
  display: flex;
  flex-direction: column;
  --panel-padding: 4px;
  border-radius: var(--mantine-radius-xl) !important;
}

.nightbot-FeatureSection-module__featurePanelContent-VN65A {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
  height: 256px;
  border-radius: var(--mantine-radius-lg);
  border-bottom-right-radius: var(--mantine-radius-sm);
  border-bottom-left-radius: var(--mantine-radius-sm);
  background: var(--background-secondary);
  border-width: 1px;
  border-color: var(--border-primary);
  pointer-events: none;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.nightbot-FeatureSection-module__featurePanelContent-VN65A::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.15;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.nightbot-FeatureSection-module__featurePanelContent-VN65A::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background: radial-gradient(circle at top, transparent, var(--background-secondary));
}

.nightbot-FeatureSection-module__featurePanelInfo-Orc_Z {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 36px 24px;
}

.nightbot-FeatureSection-module__chatFilterPanel-Sigc8,
.nightbot-FeatureSection-module__chatInteractionPanel-lRhrQ,
.nightbot-FeatureSection-module__integrationPanel-uUSPO,
.nightbot-FeatureSection-module__scheduledAnnouncementPanel-HQLrr {
  width: 100%;
  max-width: 400px;
  height: 64px;
}

.nightbot-FeatureSection-module__title-ISRdV {
  font-size: 32px;
  margin-bottom: 16px;
}

.nightbot-FeatureSection-module__description-bhABL {
  max-width: 600px;
  margin-bottom: 64px;
}


`, "",{"version":3,"sources":["webpack://./src/components/landing/FeatureSection.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,oDAAoD;EACpD,mDAAmD;EACnD,uCAAuC;EACvC,iBAAiB;EACjB,mCAAmC;EACnC,oBAAoB;EACpB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAY;EACZ,UAAU;EACV,yDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".featureSectionContainer {\n  width: 100%;\n  background-color: var(--background-secondary);\n}\n\n.featurePanels {\n  gap: 32px;\n}\n\n.featurePanel {\n  overflow: hidden;\n  gap: 8px;\n  display: flex;\n  flex-direction: column;\n  --panel-padding: 4px;\n  border-radius: var(--mantine-radius-xl) !important;\n}\n\n.featurePanelContent {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  display: grid;\n  place-items: center;\n  height: 256px;\n  border-radius: var(--mantine-radius-lg);\n  border-bottom-right-radius: var(--mantine-radius-sm);\n  border-bottom-left-radius: var(--mantine-radius-sm);\n  background: var(--background-secondary);\n  border-width: 1px;\n  border-color: var(--border-primary);\n  pointer-events: none;\n  user-select: none;\n}\n\n.featurePanelContent::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 15%;\n  z-index: 0;\n  background-image: url('@/assets/gridConnector.png');\n}\n\n.featurePanelContent::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n  background: radial-gradient(circle at top, transparent, var(--background-secondary));\n}\n\n.featurePanelInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 36px 24px;\n}\n\n.chatFilterPanel,\n.chatInteractionPanel,\n.integrationPanel,\n.scheduledAnnouncementPanel {\n  width: 100%;\n  max-width: 400px;\n  height: 64px;\n}\n\n.title {\n  font-size: 32px;\n  margin-bottom: 16px;\n}\n\n.description {\n  max-width: 600px;\n  margin-bottom: 64px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featureSectionContainer": `nightbot-FeatureSection-module__featureSectionContainer-Zn9fx`,
	"featurePanels": `nightbot-FeatureSection-module__featurePanels-sP3KG`,
	"featurePanel": `nightbot-FeatureSection-module__featurePanel-nbYWi`,
	"featurePanelContent": `nightbot-FeatureSection-module__featurePanelContent-VN65A`,
	"featurePanelInfo": `nightbot-FeatureSection-module__featurePanelInfo-Orc_Z`,
	"chatFilterPanel": `nightbot-FeatureSection-module__chatFilterPanel-Sigc8`,
	"chatInteractionPanel": `nightbot-FeatureSection-module__chatInteractionPanel-lRhrQ`,
	"integrationPanel": `nightbot-FeatureSection-module__integrationPanel-uUSPO`,
	"scheduledAnnouncementPanel": `nightbot-FeatureSection-module__scheduledAnnouncementPanel-HQLrr`,
	"title": `nightbot-FeatureSection-module__title-ISRdV`,
	"description": `nightbot-FeatureSection-module__description-bhABL`
};
export default ___CSS_LOADER_EXPORT___;
